import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import Button from '@helsenorge/designsystem-react/components/Button';
import Dropdown from '@helsenorge/designsystem-react/components/Dropdown';
import FormGroup from '@helsenorge/designsystem-react/components/FormGroup';
import Icon from '@helsenorge/designsystem-react/components/Icon';
import ChevronLeft from '@helsenorge/designsystem-react/components/Icons/ChevronLeft';
import Spacer from '@helsenorge/designsystem-react/components/Spacer';
import { useResourcesContext } from './resources';
import OffCanvas from '../offcanvas';
import styles from './styles.module.scss';
const FilterGroup = (props) => {
    const { isMobile, label, placeholder, children, onClose } = props;
    const [showMobileFilterState, setShowMobileFilterState] = React.useState(false);
    const resources = useResourcesContext();
    const handleToggleMobileFilterState = () => {
        setShowMobileFilterState(!showMobileFilterState);
    };
    const offCanvasHeader = (_jsx(_Fragment, { children: _jsxs(Button, { variant: 'borderless', onClick: handleToggleMobileFilterState, children: [_jsx(Icon, { svgIcon: ChevronLeft }), resources.mobileBackToFilters] }) }));
    return (_jsx("div", { children: isMobile ? (_jsxs(_Fragment, { children: [_jsx(Button, { className: styles['filter-options__mobile-button'], "aria-expanded": showMobileFilterState, onClick: handleToggleMobileFilterState, arrow: "icon", fluid: true, variant: 'outline', children: label || resources.filterGroupLabel }), _jsxs(OffCanvas, { header: offCanvasHeader, isOpened: showMobileFilterState, onClose: () => {
                        onClose && onClose();
                        handleToggleMobileFilterState();
                    }, children: [_jsx(FormGroup, { legend: label, name: label, children: children }), _jsx(Spacer, { size: 'xs' }), _jsx(Button, { onClick: () => {
                                onClose && onClose();
                                handleToggleMobileFilterState();
                            }, className: "right", children: resources.mobileApplyFilter })] })] })) : (_jsx("div", { className: styles['filter-options__dropdown'], children: _jsx(Dropdown, { onToggle: isOpened => {
                    !isOpened && onClose && onClose();
                }, placeholder: placeholder || resources.filterGroupPlaceholder, label: label || resources.filterGroupLabel, closeText: resources.filterGroupClose, children: children }) })) }));
};
FilterGroup.displayName = 'FilterGroup';
export default FilterGroup;
